import React from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { AuthContext } from 'contexts';
import { UserRoles } from '@bb/users';
import { Feature } from '@bb/automaton';
import { useListingRedirect } from 'hooks';

const FEATURE_ROUTE_MAP: Record<
  string,
  Array<Feature | `${Feature}`>
> = {
  '/listing/list/admin/0': ['MY_BROKERAGE'],
  '/listing/list/deleted/0': ['MY_BROKERAGE'],
  '/listing/list/brokerage/0': ['MY_BROKERAGE'],
  '/needs/0': ['MY_BROKERAGE'],
  '/open_houses': ['MY_BROKERAGE'],
  '/announcement/list': ['MY_BROKERAGE'],
  '/announcement/new': ['MY_BROKERAGE'],
  '/admin/answering': ['MY_BROKERAGE'],
  '/listing/list/team/0': ['TEAMS'],
  '/appointment/list/team': ['TEAMS'],
};

// Redirects angular routes to feature-missing
const FeatureRedirects: React.FC = ({ children }) => {
  const history = useHistory();
  const { auth, hasFeature } = React.useContext(AuthContext);
  const { fetching, unauthorizedByListing } = useListingRedirect();

  const redirectToPath = (pathname: string) => {
    // special case for admin queue
    if (
      pathname === '/admin/dashboard' &&
      !hasFeature('MY_BROKERAGE') &&
      auth.role !== UserRoles['Team Admin']
    ) {
      return '/feature-missing';
    }

    if (FEATURE_ROUTE_MAP[pathname]?.some(feature => !hasFeature(feature))) {
      return '/feature-missing';
    }

    if (
      !fetching &&
      !auth?.assumingUserId &&
      !auth?.isAssumedNotBB &&
      unauthorizedByListing
    ) {
      return '/feature-missing';
    }

    return null;
  };

  const redirect = redirectToPath(history.location.pathname);
  if (redirect) {
    return <Redirect to={redirect} />;
  }

  return <>{children}</>;
};

export default FeatureRedirects;
